import React from 'react';

import {Typography, Skeleton} from '@mui/material';
import TablePaginationActions, {
	type TablePaginationActionsProps,
} from '@mui/material/TablePagination/TablePaginationActions';

export interface VirtualizedListPagerProps extends TablePaginationActionsProps {
	loading?: boolean;
	visibleStartIndex: number;
	visibleStopIndex: number;
}

import {styled} from '@netx/core-components/Theme';

const VirtualizedListPagerRoot = styled('div', {
	name: 'VirtualizedListPager',
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	alignItems: 'center',
}));

const VirtualizedListPagerLabel = styled('div', {
	name: 'VirtualizedListPager',
	slot: 'Label',
})(({theme}) => ({
	paddingRight: theme.spacing(1),
}));

export const VirtualizedListPagerPrimitive = (
	props: VirtualizedListPagerProps,
) => {
	const {visibleStartIndex, visibleStopIndex, loading, page, ...sendProps} =
		props;
	let currentPage = page;
	if (visibleStopIndex === props.count - 1)
		currentPage = Math.floor(props.count / props.rowsPerPage);
	return (
		<VirtualizedListPagerRoot>
			<VirtualizedListPagerLabel>
				{loading ? (
					<Skeleton width={75} />
				) : (
					<Typography variant="body2">
						{(visibleStartIndex + 1).toLocaleString() + ' '}-{' '}
						{(visibleStopIndex + 1).toLocaleString() + ' '}of{' '}
						{props.count.toLocaleString()}
					</Typography>
				)}
			</VirtualizedListPagerLabel>
			<TablePaginationActions
				{...sendProps}
				count={loading ? 0 : sendProps.count}
				page={loading ? 0 : currentPage}
			/>
		</VirtualizedListPagerRoot>
	);
};

export const VirtualizedListPager = VirtualizedListPagerPrimitive;
export default VirtualizedListPager;
